import React from 'react';
import styles from './Table.module.css';

const clsx = (...args) => args.filter(Boolean).join(' ');

export function Table({ children, scrollable = true, className, ...rest }) {
  const table = (
    <table className={clsx(styles.table, className)} {...rest}>
      {children}
    </table>
  );
  return scrollable ? <div className={styles.wrapper}>{table}</div> : table;
}

export function TableHead({ children, className, ...rest }) {
  return (
    <thead className={clsx(styles.thead, className)} {...rest}>
      {children}
    </thead>
  );
}

export function TableBody({ children, className, ...rest }) {
  return (
    <tbody className={clsx(styles.tbody, className)} {...rest}>
      {children}
    </tbody>
  );
}

export function TableRow({
  children,
  variant = 'default',
  className,
  ...rest
}) {
  const cls = clsx(
    styles.tr,
    variant === 'muted' && styles.trMuted,
    variant === 'total' && styles.trTotal,
    className
  );
  return (
    <tr className={cls} {...rest}>
      {children}
    </tr>
  );
}

export function TableHeaderCell({
  children,
  numeric = false,
  align,
  className,
  ...rest
}) {
  const cls = clsx(
    styles.th,
    numeric && styles.numeric,
    align && styles[`align-${align}`],
    className
  );
  return (
    <th className={cls} {...rest}>
      {children}
    </th>
  );
}

export function TableCell({
  children,
  numeric = false,
  mono = false,
  align,
  className,
  ...rest
}) {
  const cls = clsx(
    styles.td,
    numeric && styles.numeric,
    mono && styles.mono,
    align && styles[`align-${align}`],
    className
  );
  return (
    <td className={cls} {...rest}>
      {children}
    </td>
  );
}

export default Table;
